import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MzBaseModal } from "ng2-materialize";
import { EventEmitter } from "@angular/core";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-confirm-sync",
  templateUrl: "./confirm-sync.component.html",
  styleUrls: ["./confirm-sync.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmSyncComponent extends MzBaseModal {
  readonly result: EventEmitter<any> = new EventEmitter();
  env: any = environment;

  constructor() {
    super();
  }

  okClick() {
    this.result.emit(true);
  }

  abortClick() {
    this.result.emit(false);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/confirm-sync/confirm-sync.component.ts